import { theme } from "antd"

export default function useColors() {
    const { useToken } = theme
    const { token } = useToken()

    return token
}